module.exports = __webpack_public_path__ + "assets/images/29f519d1604d148c1113b4a774fc5468.jpg";